import BasicLayout from "../../layout/basic"
// 其他模块
export default {
	path: "/fzmanage/Admin",
	component: BasicLayout,
	redirect: "/businessList",
	name: "Index",
	meta: {
		mainCss: {
			width: "100%"
		},
	},
	children: [{
			path: "/index*",
			name: "index",
			meta: {
				mainCss: {
					width: "100%"
				},
			
			},
			component: () => import("@/views/index/index")
		},
		{
			path: "/businessType",
			name: "businessType",
			meta: {
				parent:{
					path:'/businessType',
					title:'企业信息',
					mosttitle:'企业管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:true,title:'企业分类',index:0
			},
			component: () => import("@/views/businessType/index")
		},
		{
			path: "/businessAdmin",
			name: "businessAdmin",
			meta: {
				parent:{
					path:'/businessList',
					title:'企业信息',
					mosttitle:'企业管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: false,keepAlive:true,title:'企业管理员',index:0
			},
			component: () => import("@/views/businessAdmin/index")
		},
		{
			path: "/businessList",
			name: "businessList",
			meta: {
				parent:{
					path:'/businessList',
					title:'企业信息',
					mosttitle:'企业管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true,keepAlive:true,title:'企业列表',index:0
			},
			component: () => import("@/views/businessList/index"),
		},
		{
			path: "/editBusiness",
			name: "editBusiness",
			meta: {
				parent:{
					path:'/businessList',
					title:'企业列表',
					mosttitle:'企业信息',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增企业',index:0
			},
			component: () => import("@/views/businessList/editBusiness/index")
		},{
			path: "/businessDetail",
			name: "businessDetail",
			meta: {
				parent:{
					path:'/businessList',
					title:'企业列表',
					mosttitle:'企业信息',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'企业详情',index:0
			},
			component: () => import("@/views/businessList/businessDetail/index")
		},
		{
			path: "/editAdminbuss",
			name: "editAdminbuss",
			meta: {
				parent:{
					path:'/businessAdmin',
					title:'企业管理员',
					mosttitle:'企业信息',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增账号',index:0
			},
			component: () => import("@/views/businessAdmin/editAdminbuss/index")
		},
		{
			path: "/adminDetail",
			name: "adminDetail",
			meta: {
				parent:{
					path:'/businessAdmin',
					title:'企业管理员',
					mosttitle:'企业信息',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'企业管理员详情',index:0
			},
			component: () => import("@/views/businessAdmin/adminDetail/index")
		},
		{
			path: "/helpList",
			name: "helpList",
			meta: {
				parent:{
					path:'/helpList',
					title:'帮助管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'帮助列表',index:1
			},
			component: () => import("@/views/helpList/index"),
		},{
			path: "/editHelpInfo",
			name: "editHelpInfo",
			meta: {
				parent:{
					path:'/helpList',
					title:'帮助列表',
					mosttitle:'帮助管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增帮助',index:1
			},
			component: () => import("@/views/helpList/editHelpInfo/index")
		},
		{
			path: "/helpChapter",
			name: "helpChapter",
			meta: {
				parent:{
					path:'/helpList',
					title:'帮助列表',
					mosttitle:'帮助管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增章节',index:1
			},
			component: () => import("@/views/helpList/helpChapter/index")
		},{
			path: "/upContent",
			name: "upContent",
			meta: {
				parent:{
					path:'/helpList',
					title:'帮助列表',
					mosttitle:'帮助管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增章节',index:1
			},
			component: () => import("@/views/helpList/upContent/index")
		},
		{
			path: "/upcontentDetail",
			name: "upcontentDetail",
			meta: {
				parent:{
					path:'/helpList',
					title:'帮助列表',
					mosttitle:'帮助管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'上传内容',index:1
			},
			component: () => import("@/views/helpList/upcontentDetail/index")
		},
		{
			path: "/authList",
			name: "authList",
			meta: {
				parent:{
					path:'/helpList',
					title:'帮助列表',
					mosttitle:'帮助管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'设置权限',index:1
			},
			component: () => import("@/views/helpList/authList/index")
		},
		{
			path: "/Application",
			name: "Application",
			meta: {
				parent:{
					path:'/Application',
					title:'应用管理',
					mosttitle:'应用管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'应用列表',index:2
			},
			component: () => import("@/views/Application/index")
		},{
			path: "/ApplicationType",
			name: "ApplicationType",
			meta: {
				parent:{
					path:'/Application',
					title:'应用管理',
					mosttitle:'应用管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'应用分类',index:2
			},
			component: () => import("@/views/ApplicationType/index")
		},
		{
			path: "/ApplicationLog",
			name: "ApplicationLog",
			meta: {
				parent:{
					path:'/Application',
					title:'应用管理',
					mosttitle:'应用管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'应用日志',index:2
			},
			component: () => import("@/views/ApplicationLog/index")
		},
		{
			path: "/AppConditions",
			name: "AppConditions",
			meta: {
				parent:{
					path:'/AppConditions',
					title:'仿真工况',
					mosttitle:'仿真工况'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'工况列表',index:2
			},
			component: () => import("@/views/Application/AppConditions/index")
		},
		{
			path: "/AppAlarm",
			name: "AppAlarm",
			meta: {
				parent:{
					path:'/AppAlarm',
					title:'报警规则',
					mosttitle:'报警规则'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'报警规则',index:2
			},
			component: () => import("@/views/Application/AppAlarm/index")
		},
		{
			path: "/addAlarm",
			name: "addAlarm",
			meta: {
				parent:{
					path:'/AppAlarm',
					title:'报警规则',
					mosttitle:'报警规则',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增报警规则',index:2
			},
			component: () => import("@/views/Application/AppAlarm/addAlarm")
		},
		{
			path: "/AppAlarmClass",
			name: "AppAlarmClass",
			meta: {
				parent:{
					path:'/AppAlarm',
					title:'报警规则',
					mosttitle:'报警规则'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'报警分类',index:2
			},
			component: () => import("@/views/Application/AppAlarm/AppAlarmClass")
		},
		{
			path: "/editOm",
			name: "editOm",
			meta: {
				parent:{
					path:'/AppConditions',
					title:'工况列表',
					mosttitle:'仿真工况',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增工况',index:2
			},
			component: () => import("@/views/Application/AppConditions/editOm")
		},
		{
			path: "/omDetail",
			name: "omDetail",
			meta: {
				parent:{
					path:'/AppConditions',
					title:'工况列表',
					mosttitle:'仿真工况',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'工况详情',index:2
			},
			component: () => import("@/views/Application/AppConditions/omDetail")
		},
		{
			path: "/AppIssue",
			name: "AppIssue",
			meta: {
				parent:{
					path:'/AppIssue',
					title:'问题反馈',
					mosttitle:'问题反馈'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'反馈列表',index:2
			},
			component: () => import("@/views/Application/AppIssue/index")
		},
			{
			path: "/issueDetail",
			name: "issueDetail",
			meta: {
				parent:{
					path:'/AppIssue',
					title:'问题反馈',
					mosttitle:'问题反馈',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'反馈详情',index:2
			},
			component: () => import("@/views/Application/AppIssue/issueDetail")
		},
		{
			path: "/editApplication",
			name: "editApplication",
			meta: {
				parent:{
					path:'/Application',
					title:'应用列表',
					mosttitle:'应用管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增应用',index:2
			},
			component: () => import("@/views/Application/editApplication/index")
		},
		{
			path: "/Appedition",
			name: "Appedition",
			meta: {
				parent:{
					path:'/Application',
					title:'应用列表',
					mosttitle:'应用管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'应用版本',index:2
			},
			component: () => import("@/views/Application/Appedition/index")
		},
		{
			path: "/addAppediton",
			name: "addAppediton",
			meta: {
				parent:{
					path:'/Application',
					title:'应用列表',
					mosttitle:'应用管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增版本',index:2
			},
			component: () => import("@/views/Application/addAppediton/index")
		},
		{
			path: "/AppAuth",
			name: "AppAuth",
			meta: {
				parent:{
					path:'/AppAuth',
					title:'授权管理',
					mosttitle:'授权管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'应用授权',index:3
			},
			component: () => import("@/views/AppAuth/index")
		},{
			path: "/addAppAuth",
			name: "addAppAuth",
			meta: {
				parent:{
					path:'/AppAuth',
					title:'授权管理',
					mosttitle:'授权管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增授权',index:3
			},
			component: () => import("@/views/AppAuth/addAppAuth/index")
		},{
			path: "/AppAuthDetaii",
			name: "AppAuthDetaii",
			meta: {
				parent:{
					path:'/AppAuth',
					title:'授权管理',
					mosttitle:'授权管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'授权详情',index:3
			},
			component: () => import("@/views/AppAuth/AppAuthDetaii/index")
		},
		{
			path: "/courseAuth",
			name: "courseAuth",
			meta: {
				parent:{
					path:'/Application',
					title:'应用管理',
					mosttitle:'应用管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'课程授权',index:3
			},
			component: () => import("@/views/AppAuth/courseAuth/index")
		},
		{
			path: "/addCourseAuth",
			name: "addCourseAuth",
			meta: {
				parent:{
					path:'/courseAuth',
					title:'授权管理',
					mosttitle:'授权管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增授权',index:3
			},
			component: () => import("@/views/AppAuth/courseAuth/addCourseAuth")
		},
		{
			path: "/courseAuthDetail",
			name: "courseAuthDetail",
			meta: {
				parent:{
					path:'/courseAuth',
					title:'授权管理',
					mosttitle:'授权管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'授权详情',index:3
			},
			component: () => import("@/views/AppAuth/courseAuth/courseAuthDetail")
		},
		{
			path: "/User",
			name: "User",
			meta: {
				parent:{
					path:'/User',
					title:'用户管理',
					mosttitle:'用户管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'注册用户',index:4
			},
			component: () => import("@/views/User/index")
		},{
			path: "/UserClue",
			name: "UserClue",
			meta: {
				parent:{
					path:'/User',
					title:'用户管理',
					mosttitle:'用户管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'线索管理',index:4
			},
			component: () => import("@/views/User/UserClue/index")
		},
		{
			path: "/Connection",
			name: "Connection",
			meta: {
				parent:{
					path:'/User',
					title:'用户管理',
					mosttitle:'用户管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'客户咨询',index:4
			},
			component: () => import("@/views/User/UserClue/Connection")
		},
		{
			path: "/Points",
			name: "Points",
			meta: {
				parent:{
					path:'/Points',
					title:'用户管理',
					mosttitle:'用户管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'积分管理',index:4
			},
			component: () => import("@/views/User/Points/index")
		},{
			path: "/poinsDetail",
			name: "poinsDetail",
			meta: {
				parent:{
					path:'/Points',
					title:'积分管理',
					mosttitle:'积分管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'积分明细',index:4
			},
			component: () => import("@/views/User/Points/poinsDetail/index")
		},
		{
			path: "/HomeWebsite",
			name: "HomeWebsite",
			meta: {
				parent:{
					path:'/HomeWebsite',
					title:'页面配置',
					mosttitle:'页面配置'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'轮播图管理',index:5
			},
			component: () => import("@/views/HomeWebsite/banner/index")
		},{
			path: "/viewConfig",
			name: "viewConfig",
			meta: {
				parent:{
					path:'/HomeWebsite',
					title:'页面配置',
					mosttitle:'页面配置'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'主页展示配置',index:5
			},
			component: () => import("@/views/HomeWebsite/indexConfig/index")
		},{
			path: "/hlrjConfig",
			name: "hlrjConfig",
			meta: {
				parent:{
					path:'/HomeWebsite',
					title:'页面配置',
					mosttitle:'页面配置'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'主页展示配置',index:5
			},
			component: () => import("@/views/HomeWebsite/indexConfig1/index")
		},
		{
			path: "/TouchScreen",
			name: "TouchScreen",
			meta: {
				parent:{
					path:'/HomeWebsite',
					title:'页面配置',
					mosttitle:'页面配置'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'触控屏内容',index:5
			},
			component: () => import("@/views/HomeWebsite/TouchScreen/index")
		},
		{
			path: "/Solution",
			name: "Solution",
			meta: {
				parent:{
					path:'/Solution',
					title:'解决方案',
					mosttitle:'解决方案'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'解决方案',index:5
			},
			component: () => import("@/views/HomeWebsite/Solution/index")
		},
		{
			path: "/SolutionClass",
			name: "SolutionClass",
			meta: {
				parent:{
					path:'/Solution',
					title:'解决方案',
					mosttitle:'解决方案'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'解决方案分类',index:5
			},
			component: () => import("@/views/HomeWebsite/SolutionClass/index")
		},{
			path: "/Case",
			name: "Case",
			meta: {
				parent:{
					path:'/Case',
					title:'典型案例',
					mosttitle:'典型案例'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'经典案例',index:5
			},
			component: () => import("@/views/HomeWebsite/Case/index")
		},{
			path: "/CaseClass",
			name: "CaseClass",
			meta: {
				parent:{
					path:'/Case',
					title:'典型案例',
					mosttitle:'典型案例'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'案例分类',index:5
			},
			component: () => import("@/views/HomeWebsite/CaseClass/index")
		},
		{
			path: "/addCase",
			name: "addCase",
			meta: {
				parent:{
					path:'/Case',
					title:'典型案例',
					mosttitle:'官网管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增案例',index:5
			},
			component: () => import("@/views/HomeWebsite/Case/addCase/index")
		},
		{
			path: "/News",
			name: "News",
			meta: {
				parent:{
					path:'/News',
					title:'新闻动态',
					mosttitle:'新闻动态'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'新闻动态',index:5
			},
			component: () => import("@/views/HomeWebsite/News/index")
		},
		{
			path: "/addNews",
			name: "addNews",
			meta: {
				parent:{
					path:'/News',
					title:'新闻动态',
					mosttitle:'官网管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增新闻',index:5
			},
			component: () => import("@/views/HomeWebsite/News/addNews/index")
		},
		{
			path: "/NewsClass",
			name: "NewsClass",
			meta: {
				parent:{
					path:'/News',
					title:'新闻动态',
					mosttitle:'新闻动态'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'新闻分类',index:5
			},
			component: () => import("@/views/HomeWebsite/NewsClass/index")
		},
		{
			path: "/recruit",
			name: "recruit",
			meta: {
				parent:{
					path:'/recruit',
					title:'人才招聘',
					mosttitle:'人才招聘'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'人才岗位',index:5
			},
			component: () => import("@/views/HomeWebsite/recruit/index")
		},
		{
			path: "/recruitDoc",
			name: "recruitDoc",
			meta: {
				parent:{
					path:'/recruit',
					title:'人才岗位',
					mosttitle:'人才招聘',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'简历总览',index:5
			},
			component: () => import("@/views/HomeWebsite/recruit/recruitDoc/index")
		},
		{
			path: "/addRecruit",
			name: "addRecruit",
			meta: {
				parent:{
					path:'/recruit',
					title:'人才岗位',
					mosttitle:'人才招聘',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增人才',index:5
			},
			component: () => import("@/views/HomeWebsite/recruit/addRecruit/index")
		},
		{
			path: "/recruitClass",
			name: "recruitClass",
			meta: {
				parent:{
					path:'/recruit',
					title:'人才招聘',
					mosttitle:'人才招聘'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'岗位分类',index:5
			},
			component: () => import("@/views/HomeWebsite/recruitClass/index")
		},
		{
			path: "/addBanner",
			name: "addBanner",
			meta: {
				parent:{
					path:'/HomeWebsite',
					title:'轮播图管理',
					mosttitle:'官网管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增轮播图',index:5
			},
			component: () => import("@/views/HomeWebsite/banner/addBanner/index")
		},
		{
			path: "/bannerSort",
			name: "bannerSort",
			meta: {
				parent:{
					path:'/HomeWebsite',
					title:'轮播图管理',
					mosttitle:'官网管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'轮播图排序',index:5
			},
			component: () => import("@/views/HomeWebsite/banner/bannerSort/index")
		},
		{
			path: "/addTouch",
			name: "addTouch",
			meta: {
				parent:{
					path:'/TouchScreen',
					title:'页面配置',
					mosttitle:'页面配置',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增触摸屏内容',index:5
			},
			component: () => import("@/views/HomeWebsite/TouchScreen/addTouch/index")
		},{
			path: "/touchDetail",
			name: "touchDetail",
			meta: {
				parent:{
					path:'/TouchScreen',
					title:'页面配置',
					mosttitle:'页面配置',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'内容详情',index:5
			},
			component: () => import("@/views/HomeWebsite/TouchScreen/addTouch/touchDetail.vue")
		},{
			path: "/touchDetail1",
			name: "touchDetail1",
			meta: {
				parent:{
					path:'/TouchScreen',
					title:'页面配置',
					mosttitle:'页面配置',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'内容详情',index:5
			},
			component: () => import("@/views/HomeWebsite/TouchScreen/addTouch/touchDetail1.vue")
		},
		{
			path: "/addSolution",
			name: "addSolution",
			meta: {
				parent:{
					path:'/Solution',
					title:'解决方案',
					mosttitle:'官网管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增解决方案',index:5
			},
			component: () => import("@/views/HomeWebsite/Solution/addSolution/index")
		},
		{
			path: "/Transaction",
			name: "Transaction",
			meta: {
				parent:{
					path:'/Transaction',
					title:'交易管理',
					mosttitle:'交易管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'订单列表',index:6
			},
			component: () => import("@/views/Transaction/Order/index")
		},
		{
			path: "/orderDetail",
			name: "orderDetail",
			meta: {
				parent:{
					path:'/Transaction',
					title:'订单管理',
					mosttitle:'交易管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'订单详情',index:6
			},
			component: () => import("@/views/Transaction/Order/orderDetail/index")
		},{
			path: "/testPapeList",
			name: "testPapeList",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷管理',
					mosttitle:'试卷管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'试卷列表',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/index")
		},
		{
			path: "/addPaper",
			name: "addPaper",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增试卷',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/addPaper/index")
		},{
			path: "/twoIndex",
			name: "twoIndex",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增试卷',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/addPaper/twoIndex")
		},{
			path: "/threeIndex",
			name: "threeIndex",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增试卷',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/addPaper/threeIndex")
		},
		{
			path: "/scoreAnalysis",
			name: "scoreAnalysis",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'统计分析',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/scoreAnalysis/index.vue")
		},	{
			path: "/examLog",
			name: "examLog",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'考试记录',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/scoreAnalysis/examLog.vue")
		},
		{
			path: "/moniToring",
			name: "moniToring",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'考试监控',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/moniToring/index.vue")
		},{
			path: "/GradingPaper",
			name: "GradingPaper",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'批卷',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/moniToring/GradingPaper.vue")
		},
		{
			path: "/previewPaper",
			name: "previewPaper",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览考试',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/previewPaper/index.vue")
		},{
			path: "/PrintingPaper",
			name: "PrintingPaper",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'打印试卷',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/PrintingPaper/index.vue")
		},{
			path: "/ExportWord",
			name: "ExportWord",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'导出Word',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/ExportWord/index.vue")
		},
		{
			path: "/listexams",
			name: "listexams",
			meta: {
				parent:{
					path:'/testPapeList',
					title:'试卷列表',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'进入考试',index:7
			},
			component: () => import("@/views/testPaper/testPapeList/previewPaper/listexams/index.vue")
		},
		{
			path: "/testPaperClass",
			name: "testPaperClass",
			meta: {
				parent:{
					path:'/testPaperClass',
					title:'试卷管理',
					mosttitle:'试卷管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'试卷分类',index:7
			},
			component: () => import("@/views/testPaper/testPaperClass/index")
		},{
			path: "/topicList",
			name: "topicList",
			meta: {
				parent:{
					path:'/topicList',
					title:'题库管理',
					mosttitle:'试卷管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'题目列表',index:7
			},
			component: () => import("@/views/testPaper/topicList/index")
		},{
			path: "/addTopic",
			name: "addTopic",
			meta: {
				parent:{
					path:'/topicList',
					title:'题库管理',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增题目',index:7
			},
			component: () => import("@/views/testPaper/topicList/addTopic/index")
		},
		{
			path: "/previewTopic",
			name: "previewTopic",
			meta: {
				parent:{
					path:'/topicList',
					title:'题库管理',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览题目',index:7
			},
			component: () => import("@/views/testPaper/topicList/previewTopic/index")
		},{
			path: "/topicCount",
			name: "topicCount",
			meta: {
				parent:{
					path:'/topicList',
					title:'题库管理',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'题目统计',index:7
			},
			component: () => import("@/views/testPaper/topicList/topicCount/index")
		},
		{
			path: "/repeaTopic",
			name: "repeaTopic",
			meta: {
				parent:{
					path:'/topicList',
					title:'题库管理',
					mosttitle:'试卷管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'题库去重',index:7
			},
			component: () => import("@/views/testPaper/topicList/repeaTopic/index")
		},
		{
			path: "/topicClass",
			name: "topicClass",
			meta: {
				parent:{
					path:'/topicClass',
					title:'题库管理',
					mosttitle:'试卷管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'题目分类',index:7
			},
			component: () => import("@/views/testPaper/topicClass/index")
		},{
			path: "/topicImport",
			name: "topicImport",
			meta: {
				parent:{
					path:'/topicImport',
					title:'题库管理',
					mosttitle:'试卷管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'批量导入',index:7
			},
			component: () => import("@/views/testPaper/topicImport/index")
		},{
			path: "/twoSteps",
			name: "twoSteps",
			meta: {
				parent:{
					path:'/topicImport',
					title:'题库管理',
					mosttitle:'批量导入',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'批量导入',index:7
			},
			component: () => import("@/views/testPaper/topicImport/twoSteps/index")
		},
		{
			path: "/simulationPaper",
			name: "simulationPaper",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理'
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'仿真试卷列表',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/index")
		},
		{
			path: "/addRaso",
			name: "addRaso",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加仿真试卷',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/addRaso/index")
		},{
			path: "/twoRaso",
			name: "twoRaso",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加仿真试卷',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/addRaso/twoIndex")
		},
		{
			path: "/endRaso",
			name: "endRaso",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'添加仿真试卷',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/addRaso/endIndex")
		},
		{
			path: "/importStep",
			name: "importStep",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'导入过程步骤',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/importStep/index")
		},
		{
			path: "/rasoAnalysis",
			name: "rasoAnalysis",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'统计分析',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/rasoAnalysis/index")
		},{
			path: "/rasoExamLog",
			name: "rasoExamLog",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'考试记录',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/rasoAnalysis/rasoExamLog")
		},{
			path: "/rasoMoniToring",
			name: "rasoMoniToring",
			meta: {
				parent:{
					path:'/simulationPaper',
					title:'仿真考试管理',
					mosttitle:'仿真考试管理',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'考试监控',index:7
			},
			component: () => import("@/views/testPaper/simulationPaper/rasoMoniToring/index")
		},
		{
			path: "/ElectronicCard",
			name: "ElectronicCard",
			meta: {
				parent:{
					path:'/ElectronicCard',
					title:'电子名片',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'电子名片',index:8
			},
			component: () => import("@/views/ElectronicCard/index"),
		},
		{
			path: "/cardDetail",
			name: "cardDetail",
			meta: {
				parent:{
					path:'/ElectronicCard',
					title:'电子名片',
					mosttitle:'电子名片详情',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'电子名片详情',index:8
			},
			component: () => import("@/views/ElectronicCard/cardDetail")
		},
		{
			path: "/Course",
			name: "Course",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'课程管理',index:9
			},
			component: () => import("@/views/Course/index"),
		},
		{
			path: "/addCourse",
			name: "addCourse",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增课程',index:9
			},
			component: () => import("@/views/Course/addCourse/index"),
		},{
			path: "/twoCourse",
			name: "twoCourse",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增课程',index:9
			},
			component: () => import("@/views/Course/addCourse/twoCourse"),
		},
		{
			path: "/threeCourse",
			name: "threeCourse",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增课程',index:9
			},
			component: () => import("@/views/Course/addCourse/threeCourse"),
		},
		{
			path: "/batchSection",
			name: "batchSection",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'批量新增小节',index:9
			},
			component: () => import("@/views/Course/addCourse/batchSection"),
		},{
			path: "/oneSection",
			name: "oneSection",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增小节',index:9
			},
			component: () => import("@/views/Course/addCourse/oneSection"),
		},{
			path: "/previewSection",
			name: "previewSection",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览小节',index:9
			},
			component: () => import("@/views/Course/addCourse/previewSection"),
		},
		{
			path: "/upcontentCourseDetail",
			name: "upcontentCourseDetail",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'上传内容',index:9
			},
			component: () => import("@/views/Course/addCourse/upcontentCourseDetail/index.vue"),
		},
		{
			path: "/courseData",
			name: "courseData",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'统计分析',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'统计分析',index:9
			},
			component: () => import("@/views/Course/courseData/index.vue"),
		},
		{
			path: "/previewCourse",
			name: "previewCourse",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'预览课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览课程',index:9
			},
			component: () => import("@/views/Course/previewCourse/index.vue"),
		},
		{
			path: "/previewCourseDetail",
			name: "previewCourseDetail",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'预览课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览课程',index:9
			},
			component: () => import("@/views/Course/previewCourse/previewCourseDetail.vue"),
		},{
			path: "/courseVideo",
			name: "courseVideo",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'预览课程',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览课程',index:9
			},
			component: () => import("@/views/Course/previewCourse/courseVideo.vue"),
		},
		{
			path: "/courseClass",
			name: "courseClass",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'课程分类',index:9
			},
			component: () => import("@/views/Course/courseClass/index"),
		},
		{
			path: "/materialLibrary",
			name: "materialLibrary",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'素材库',index:9
			},
			component: () => import("@/views/Course/materialLibrary/index"),
		},
		{
			path: "/addMaterial",
			name: "addMaterial",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
					mosttitle:'新增素材库',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增素材库',index:9
			},
			component: () => import("@/views/Course/materialLibrary/addMaterial.vue"),
		},
		{
			path: "/materialLibraryClass",
			name: "materialLibraryClass",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'素材库分类',index:9
			},
			component: () => import("@/views/Course/materialLibrary/libraryClass"),
		},
		{
			path: "/certiFicate",
			name: "certiFicate",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'证书列表',index:9
			},
			component: () => import("@/views/Course/certiFicate/index"),
		},{
			path: "/certiFicateClass",
			name: "certiFicateClass",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'证书分类',index:9
			},
			component: () => import("@/views/Course/certiFicate/certiFicateClass/index"),
		},{
			path: "/certiFicateStInfo",
			name: "certiFicateStInfo",
			meta: {
				parent:{
					path:'/Course',
					title:'课程管理',
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'证书学员信息',index:9
			},
			component: () => import("@/views/Course/certiFicate/certiFicateStInfo/index"),
		},
		{
			path: "/addCertSt",
			name: "addCertSt",
			meta: {
				parent:{
					path:'/certiFicateStInfo',
					title:'证书学员信息',
					mosttitle:'新增证书学员',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增证书学员',index:9
			},
			component: () => import("@/views/Course/certiFicate/certiFicateStInfo/addCertSt"),
		},{
			path: "/certAdd",
			name: "certAdd",
			meta: {
				parent:{
					path:'/certiFicate',
					title:'证书列表',
					mosttitle:'新增证书',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'新增证书',index:9
			},
			component: () => import("@/views/Course/certiFicate/certAdd/index"),
		},{
			path: "/previewCert",
			name: "previewCert",
			meta: {
				parent:{
					path:'/certiFicate',
					title:'证书列表',
					mosttitle:'预览证书',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:false,title:'预览证书',index:9
			},
			component: () => import("@/views/Course/certiFicate/previewCert/index"),
		},
		{
			path: "/certificateRecipient",
			name: "certificateRecipient",
			meta: {
				parent:{
					path:'/certiFicate',
					title:'证书列表',
					mosttitle:'领取证书',
					isShow:true
				},
				mainCss: {
					width: "100%"
				},
				requiresAuth: true ,keepAlive:true,title:'领取证书',index:9
			},
			component: () => import("@/views/Course/certiFicate/certificateRecipient/index"),
		},
	]
}
